"use client";

export function PrivacyPreferencesButton() {
  return (
    <button
      className="text-button"
      type="button"
      onClick={() => window.dispatchEvent(new Event("open-consent"))}
    >
      העדפות פרטיות
    </button>
  );
}
